<template>
  <div id="content-container">
    <ProductIndex :category="1"></ProductIndex>
  </div>
</template>

<script>
import ProductIndex from './index'

export default {
  components: {
    ProductIndex,
  },
}
</script>